import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Global } from "@emotion/react";
import {
	Box,
	Grid,
	Table,
	TableContainer,
	Paper,
	TableBody,
	TableRow,
	TableCell,
	SwipeableDrawer,
	Fab,
} from "@mui/material";
import { PersonAddAltOutlined } from "@mui/icons-material";
import useStore from "../../store/store";
import userService from "../../services/user";
import style from "../../utils/style";
import AddProfile from "../../components/AddProfile";
import PageHeading from "../../components/PageHeading";
import moment from "moment";

function Profile() {
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState(false);
	let [currUser, setCurrUser] = useState({});

	const {
		token,
		user,
		setCompany,
		setIsLoading,
		isLoggedIn,
		setErrorMessage,
		setCurrObj,
	} = useStore((state) => state);

	useEffect(() => {
		if (!isLoggedIn) navigate("/login");
		if (user.type === "owner") getCompany();
		else setCurrUser(user);
	}, []);

	const getCompany = () => {
		setIsLoading(true);
		userService.company(token).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setCompany(r.data);
				setCurrUser(r.data);
				setIsLoading(false);
			}
		});
	};

	const toggleDrawer = () => setIsOpen(!isOpen);

	const Puller = styled(Box)(() => ({
		width: 30,
		height: 6,
		backgroundColor: "#ccc",
		borderRadius: 3,
		position: "absolute",
		top: 8,
		left: "calc(50% - 15px)",
	}));

	return (
		<>
			{user.type === "owner" && (
				<Fab
					color="primary"
					aria-label="add"
					onClick={toggleDrawer}
					style={{ position: "fixed", right: 20, bottom: 80 }}
				>
					<PersonAddAltOutlined />
				</Fab>
			)}

			<Global
				styles={{
					".MuiDrawer-root > .MuiPaper-root": {
						height: `calc(95%)`,
						overflow: "visible",
						borderTopLeftRadius: 10,
						borderTopRightRadius: 10,
					},
				}}
			/>

			<SwipeableDrawer
				anchor="bottom"
				open={isOpen}
				onClose={() => {
					setCurrObj(null);
					toggleDrawer();
				}}
				onOpen={toggleDrawer}
				swipeAreaWidth={56}
				disableSwipeToOpen={true}
				ModalProps={{
					keepMounted: true,
				}}
			>
				<Puller />

				<AddProfile setIsOpen={toggleDrawer} reload={getCompany} />
			</SwipeableDrawer>

			<Grid container sx={style.container}>
				<Grid item xs={12} md={12} sx={{ mb: 2 }}>
					<PageHeading text="Profile" />
				</Grid>

				<Grid item xs={12}>
					<TableContainer component={Paper}>
						<Table>
							<TableBody>
								<TableRow
									sx={{
										"&:last-child td, &:last-child th": {
											border: 0,
										},
									}}
								>
									<TableCell align="right">
										<ion-icon
											name="person-outline"
											style={style.profileIcons}
										></ion-icon>
									</TableCell>
									<TableCell
										component="th"
										scope="row"
										align="left"
									>
										{currUser.name}
									</TableCell>
								</TableRow>
								<TableRow
									sx={{
										"&:last-child td, &:last-child th": {
											border: 0,
										},
									}}
								>
									<TableCell align="right">
										<ion-icon
											name="call-outline"
											style={style.profileIcons}
										></ion-icon>
									</TableCell>
									<TableCell
										component="th"
										scope="row"
										align="left"
									>
										{currUser.phone}
										<br />
										{currUser.additionalPhone}
									</TableCell>
								</TableRow>
								{currUser.shopName && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="storefront-outline"
												style={style.profileIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											component="th"
											scope="row"
											align="left"
										>
											{currUser.shopName}
										</TableCell>
									</TableRow>
								)}
								{currUser.address && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="location-outline"
												style={style.profileIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											component="th"
											scope="row"
											align="left"
										>
											{currUser.address}
										</TableCell>
									</TableRow>
								)}
								{currUser.desciption && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="ribbon-outline"
												style={style.profileIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											component="th"
											scope="row"
											align="left"
										>
											{currUser.desciption}
										</TableCell>
									</TableRow>
								)}
								{currUser.note && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="reader-outline"
												style={style.profileIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											component="th"
											scope="row"
											align="left"
										>
											{currUser.note}
										</TableCell>
									</TableRow>
								)}
								{currUser.nickName && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="happy-outline"
												style={style.profileIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											component="th"
											scope="row"
											align="left"
										>
											{currUser.nickName}
										</TableCell>
									</TableRow>
								)}
								<TableRow
									sx={{
										"&:last-child td, &:last-child th": {
											border: 0,
										},
									}}
								>
									<TableCell align="right">
										<ion-icon
											name="time-outline"
											style={style.profileIcons}
										></ion-icon>
									</TableCell>
									<TableCell
										component="th"
										scope="row"
										align="left"
									>
										{moment(currUser.joined).format(
											"DD MMMM YYYY"
										)}
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
		</>
	);
}

export default Profile;
